<div class="login-container">
  <form (ngSubmit)="onSaveNote()">
    <h2>{{ 'DIALOG.ADD_NOTE_TITLE' | translate }}</h2>
    <textarea
      matInput
      [placeholder]="'DIALOG.ADD_NOTE_PLACEHOLDER' | translate"
      type="text"
      [rows]="5"
      [(ngModel)]="noteText"
    ></textarea>
    <div class="add-note-button-wrapper">
      <button mat-raised-button (click)="onClose()">{{ 'DIALOG.CLOSE' | translate }}</button>
      <button mat-raised-button type="submit">{{ 'DIALOG.SAVE' | translate }}</button>
    </div>
  </form>
</div>
